import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Box, Divider, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useHistory } from 'react-router-dom';
import { Menus } from 'config/menus';
import Paths from 'config/paths';
import { listItemStyles } from '../styles';
import { dangerItemSx, NAV_ITEM_FONT_SIZE } from './styles';

/**
 * Acciones de usuario autenticado, al inicio del sidebar: "Mi Perfil" (link
 * vía mapView para respetar permisos) y "Cerrar sesión".
 */
function ProfileActions({ mapView, actions }) {
  const history = useHistory();
  const profileView = mapView('profile', Paths.PROFILE, Menus[Paths.PROFILE]);

  const handleLogout = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      localStorage.clear();
      if (actions?.logOut) actions.logOut();
      else if (actions?.setUser) actions.setUser(null);
      if (actions?.toggleDrawer) actions.toggleDrawer();
      history.push('/');
    },
    [actions, history],
  );

  return (
    <Box sx={{ px: 2, pt: 1 }}>
      <List disablePadding>
        {profileView}
        <ListItem button onClick={handleLogout} style={listItemStyles} sx={dangerItemSx}>
          <ListItemIcon sx={{ minWidth: 40, color: 'error.main' }}>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography color="error" sx={{ fontSize: NAV_ITEM_FONT_SIZE }}>
                Cerrar sesión
              </Typography>
            }
          />
        </ListItem>
      </List>
      <Divider sx={{ mt: 1 }} />
    </Box>
  );
}

ProfileActions.propTypes = {
  mapView: PropTypes.func.isRequired,
  actions: PropTypes.object,
};

export default ProfileActions;
